// @flow

import React from "react";

import { CommonComplianceKpisForm } from "@modules/service/components/common/common-compliance-kpis";
import type { ServiceKpis } from "@modules/service/types";
import { Col, Row } from "@components";

type OwnProps = $Exact<{
  data: Array<ServiceKpis>,
  title?: string,
  schema: Object,
  kpiTitle?: string,
}>;

type Props = $Exact<{
  ...OwnProps,
}>;

export class CommonComplianceKpisView extends React.Component<Props> {
  get data() {
    return this.props.data;
  }

  render() {
    return (
      <CommonComplianceKpisForm
        {...this.props}
        data={this.data}
        schema={this.props.schema}
        kpiTitle={this.props.kpiTitle}
        disabled
      />
    );
  }
}

export default CommonComplianceKpisView;
